import { useUserProfile } from 'core/hooks/useDataHook'
import { useMemo } from 'react'

const useSubscription = () => {
  const { data: userProfile } = useUserProfile()

  const isPremium = !!userProfile?.subscription

  const paywalledFeatures = useMemo(() => {
    const _paywalledFeatures = userProfile?.paywalled_features ?? {
      unlimited_mileage_tracking: {
        enabled: false
      },
      expenses_card_sync: {
        enabled: false
      },
      pdf_reports: {
        enabled: false
      },
      work_hours: {
        enabled: false
      },
      tax_filing: {
        enabled: false
      },
      audit_protection: {
        enabled: false
      },
      premium_support: {
        enabled: false
      }
    }
    return {
      unlimited_mileage_tracking: {
        ..._paywalledFeatures.unlimited_mileage_tracking,
        enabled: _paywalledFeatures.unlimited_mileage_tracking.enabled
      },
      expenses_card_sync: {
        ..._paywalledFeatures.expenses_card_sync,
        enabled: _paywalledFeatures.expenses_card_sync.enabled
      },
      pdf_reports: {
        ..._paywalledFeatures.pdf_reports,
        enabled: _paywalledFeatures.pdf_reports.enabled
      },
      work_hours: {
        ..._paywalledFeatures.work_hours,
        enabled: _paywalledFeatures.work_hours.enabled
      },
      tax_filing: {
        ..._paywalledFeatures.tax_filing,
        enabled: _paywalledFeatures.tax_filing.enabled
      },
      audit_protection: {
        ..._paywalledFeatures.audit_protection,
        enabled: _paywalledFeatures.audit_protection.enabled
      },
      premium_support: {
        ..._paywalledFeatures.premium_support,
        enabled: _paywalledFeatures.premium_support.enabled
      }
    }
  }, [userProfile?.paywalled_features])

  const subscriptionDetails = useMemo(() => {
    const { current_period_end, cancel_at_period_end } =
      userProfile?.subscription?.customer ?? {}
    return {
      freeTripsRemaining: userProfile?.free_trips_remaining,
      trialDaysRemaining:
        (userProfile?.subscription?.customer?.trial_days_remaining ?? 0) ||
        (userProfile?.trial_days_remaining ?? 0),
      isAppleSub: userProfile?.subscription?.type === 'IapSubscription',
      seats: userProfile?.subscription?.customer?.subscription?.quantity ?? 0,
      current_period_end,
      cancel_at_period_end,
      segment: userProfile?.subscription?.segment,
      isCobrand: !!userProfile?.group_as_cobrand_member
    }
  }, [
    userProfile?.free_trips_remaining,
    userProfile?.group_as_cobrand_member,
    userProfile?.subscription?.customer,
    userProfile?.subscription?.segment,
    userProfile?.subscription?.type,
    userProfile?.trial_days_remaining
  ])

  return {
    isPremium,
    paywalledFeatures,
    ...subscriptionDetails
  }
}

export default useSubscription
